export const GAPageViews = {
  Login: 'ma_login',
  Trademark: 'ma_trademark',
  Patent: 'ma_patent',
  LoginSuccess: 'ma_login_success',
  Mfa: 'ma_mfa',
  ChangePassword: 'ma_change_password',
  AccountSettings: 'ma_account_settings',
  PaymentHistory: 'ma_payment_history',
  Subscriptions: 'ma_subscriptions',
  WorkspaceSelector: 'ma_workspace_selector',
  Workspaces: 'ma_workspaces',
  OrderHistory: 'ma_order_history',

  // Personal Workspace
  Home: 'ma_home',
  Tax: 'ma_tax_upcoming',
  PastTax: 'ma_tax_past',
  Legal: 'ma_legal_upcoming',
  PastLegal: 'ma_legal_past',
  RegisteredAgent: 'ma_inbox',
  Documents: 'ma_documents',
  Orders: 'ma_orders',
  BusinessToolkit: 'ma_business_toolkit',
  DocumentEditor: 'ma_document_editor',
  ESignature: 'ma_esignature',
  AssetsManager: 'ma_assets_manager',
  AssetViewer: 'ma_asset_viewer',
  DocumentCenter: 'ma_document_center',
  Books: 'ma_books',

  // Business Workspace
  BusinessHome: 'ma_biz_details',
  BusinessSelfServeOrco: 'ma_biz_ssorco',
  BusinessDrawer: 'ma_biz_drawers',
  BusinessTax: 'ma_biz_tax_upcoming',
  BusinessPastTax: 'ma_biz_tax_past',
  BusinessLegal: 'ma_biz_legal_upcoming',
  BusinessLegalCheckout: 'ma_biz_legal_checkout',
  BusinessPastLegal: 'ma_biz_legal_past',
  BusinessRegisteredAgent: 'ma_biz_inbox',
  BusinessDocuments: 'ma_biz_documents',
  BusinessOrders: 'ma_biz_orders',
  BusinessCompliance: 'ma_biz_compliance',
  BusinessComplianceCheckout: 'ma_biz_compliance_checkout',
  BusinessBusinessToolkit: 'ma_biz_business_toolkit',
  BusinessBusinessToolkitNext: 'ma_biz_business_toolkit_next',
  BusinesssGoogleWorkspace: 'ma_biz_google_workspace',
  BusinessDocumentEditor: 'ma_biz_document_editor',
  BusinessAssetsManager: 'ma_biz_assets_manager',
  BusinessAssetViewer: 'ma_biz_asset_viewer',
  BusinessDocumentCenter: 'ma_biz_document_center',
  BusinessBooks: 'ma_biz_books',
  BusinessBooksActivation: 'ma_biz_books_activation',
  BusinessProjects: 'ma_biz_projects',
  BusinessProjectTakeover: 'ma_biz_project_takeover',
  BusinessInvoices: 'ma_biz_invoices',
  BusinessInvoiceTakeover: 'ma_biz_invoice_takeover',
  BusinessClients: 'ma_biz_clients',
  BusinessServices: 'ma_biz_services',
  BusinessTransactions: 'ma_biz_transactions',
  BusinessProfile: 'ma_biz_profile',
  BusinessReports: 'ma_reports',
  BusinessReportsCategories: 'ma_reports_categories',
  BusinessMileage: 'ma_biz_mileage',
  BusinessImportCsv: 'ma_import_csv',
  BusinessBooksTax: 'ma_biz_books_tax',
  BusinessBooksTaxMath: 'ma_biz_books_tax_math',

  // Onboarding
  OnboardingBusinessLocation: 'ma_biz_location',
  OnboardingBusinessName: 'ma_biz_name',
  OnboardingEntityType: 'ma_entity_type',
  OnboardingFormationDate: 'ma_formation_date',
  OnboardingRegistrationStage: 'ma_registration_stage',
  OnboardingWorkspaceSelection: 'ma_workspace_selection',
  OnboardingLoading: 'ma_loading',
  Onboarding: 'ma_onboarding',

  // Document Summarizer
  DocumentSummarizerHome: 'ma_document_summarizer_home',
  DocumentSummary: 'ma_document_summary',
  DocumentSharedSummary: 'ma_document_shared_summary',
  DocumentUploadNew: 'ma_document_upload_new',

  // Template Store
  TemplateStore: 'ma_template_store',

  // Universal Checkout
  Cart: 'ma_cart',
  Checkout: 'ma_checkout',
  Confirmation: 'confirmation',

  //Consultation
  ScheduleConsultation: 'ma_consultation',

  // Forms builder
  FormsBuilder: 'ma_forms_buidler',

  // Compliance Health Scan
  ComplianceHealthScan: 'ma_compliance_health_scan',

  // Signature Capture
  SignatureCapture: 'ma_signature_capture',

  // AI Contract
  AiContract: 'ma_ai_contract',
};

export type GAPageViews = (typeof GAPageViews)[keyof typeof GAPageViews];
